import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( $( '.before-and-after-slider__splide' ).length ) {
        $( '.before-and-after-slider__splide' ).each( function( index, element ) {
          const baSlider = new Splide( element, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            gap: '1rem',
            pagination: false,
            speed: 800,
          } );
          // baSlider.on( 'overflow', function( isOverflow ) {
          //   baSlider.options = {
          //     arrows: isOverflow,
          //     drag: isOverflow,
          //   };
          // } );
          baSlider.mount();
        } );

        const liveRegion = $( '.ba-slider__live-region' );

        $( '.ba-slider__toggle' ).on( 'toggleAfter', ( event ) => {
          const target = $( event.target );
          if ( target.attr( 'aria-pressed' ) ) {
            target.attr( 'aria-pressed', false );
            liveRegion.text( 'Sensitive images are visible' );
          } else {
            liveRegion.text( 'Sensitive images are blurred' );
            target.attr( 'aria-press', true );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'before-and-after', COMPONENT );
} )( app );
